import { cn } from "@/lib/utils";

interface PageWrapperProps {
    children?: React.ReactNode;
    className?: string
}

const PageWrapper: React.FC<PageWrapperProps> = ({ className, children }) => {
    return (
        <main
            className={cn("max-w-screen-2xl w-full flex justify-center px-10 py-2 flex-1", className)}
        >
            {children}
        </main>
    )
}

export default PageWrapper;
